import { render, staticRenderFns } from "./LicenseTable.vue?vue&type=template&id=3a7354fb&scoped=true&"
import script from "./LicenseTable.vue?vue&type=script&lang=js&"
export * from "./LicenseTable.vue?vue&type=script&lang=js&"
import style0 from "./LicenseTable.vue?vue&type=style&index=0&id=3a7354fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7354fb",
  null
  
)

export default component.exports